import React, { useState, useEffect } from 'react';
import SidebarItem from "./SidebarItem";
import { useJWTAuth } from "../../../services/JWTAuthProvider";
import { useNavigate } from 'react-router-dom';

export const SideMenu = (props) => {
    const { user } = useJWTAuth();
    const [sideMenuVisible, setSideMenuVisible] = useState(true);
    const [searchVal, setSearchVal] = useState('');
    const [defaultOpen, setDefaultOpen] = useState(false);
    const [filteredVal, setFilteredVal] = useState([]);
    const navigate = useNavigate();

    const toggleSideMenu = () => {
        setSideMenuVisible(!sideMenuVisible);
    };

    const onCallback = (item) => {
        if (item)
            navigate('/' + item.folderIdentifier);
    };


    const navigateToHome = () => {
        navigate('/');
    }


    useEffect(() => {
        if (searchVal && user.folders) {
            const searchFolders = (obj) => obj.name.toLowerCase().includes(searchVal.toLowerCase());

            const findMatchingFolder = (obj) => {
                // Check if the current folder matches the search criteria
                const folderMatches = searchFolders(obj);

                // If the current folder matches, return true
                if (folderMatches) {
                    return true;
                }

                // Check if any subfolder matches the search criteria
                const subFolderMatches = obj.subFolders && obj.subFolders.some((subObj) => findMatchingFolder(subObj));

                return subFolderMatches;
            };

            let val = user.folders.filter(findMatchingFolder);

            setFilteredVal(val);
        }
        else {
            setFilteredVal(user.folders);
        }
    }, [searchVal, user.folders]);

    return (
        <>
            <div className={`side-menu-icon ${sideMenuVisible ? 'menu-align' : ''}`} onClick={toggleSideMenu}>
                <img src="/Assets/menu-icon.svg" alt="Menu Icon" />
            </div>
            <div className={`side-menu-box ${sideMenuVisible ? '' : 'hidden'}`}>
                <div className="side-menu-top">
                    <div className="side-menu-logo" onClick={navigateToHome}>
                        <img src='/Assets/logo.svg' alt='Resource Center' />
                    </div>

                </div>
                <div className='sidebar-input'>
                    <input type='search' value={searchVal} onChange={
                        (e) => {
                            setSearchVal(e.target.value)
                            if (e.target.value.length > 0) {
                                setDefaultOpen(false);
                                setTimeout(() => {
                                    setDefaultOpen(true);
                                }, 1000)
                            }
                        }
                    } className='form-control' placeholder='Search Folder' />
                </div>
                {
                    user.folders && user.folders.length > 0 ?
                        <div className="sidebar">
                            {
                                filteredVal ? filteredVal.map((item, index) => <SidebarItem defaultOpen={defaultOpen} key={index} item={item} onCallback={onCallback} />)
                                    : null
                            }
                        </div>
                        :
                        <div class="folder-not-found">
                            <div class="folder-text">You dont have access to any folder.
                                <br />
                                Please contact administrator.
                            </div>
                        </div>
                }

            </div>
        </>
    );
};
